// src/App.jsx
import { Routes, Route } from 'react-router-dom'

import Header from './components/Header'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ProductDetailPage from './components/ProductDescription'
import ScrollToTop from './pages/ScrollToTop'
import ContactPage from './components/ContactForm'
import MobileFooter from './components/MobileFooter'
import Terms from './components/Terms'
import Privacy from './components/Privacy'
import Cook from './components/Cook'

function App() {

  return (
    <div className="app">
      <Header />

      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/terms and conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/cookies" element={<Cook />} />
        {/* <Route path="*" element={<NotFoundPage />} /> */}
      </Routes>
      <Footer />
      <MobileFooter />
    </div>
  )
}

export default App
